import { PRODUCTION, DEVELOPMENT, LOCAL, STAGING, E2E } from "./constants/environment";
import env from "./env";
export var forgotPasswordRedirect = function (tenant) {
    return getDomain(tenant) + "/welcome/login/reset-password";
};
export var login = function (tenant) {
    return getDomain(tenant) + "/welcome/login";
};
export var postData = function (tenant) {
    return getDomain(tenant) + "/api/setValue.html";
};
export var checkEmail = function (tenant) {
    return getDomain(tenant) + "/welcome/login/check-email";
};
export var getCDNBundleUrl = function () {
    return env.PUBLIC_URL;
};
export var insightsHome = function (subdomain) {
    return getDomain(subdomain) + "/insights";
};
export var medicalHome = function (subdomain) {
    return getDomain(subdomain) + "/medical/my-medical";
};
export var channelPartner = function (urlSlug) {
    return getDomain("app") + "/channel/" + urlSlug;
};
export var getLocaleUrl = function () {
    switch (env.ENVIRONMENT_NAME) {
        case LOCAL:
            return "http://localhost:3000";
        case DEVELOPMENT:
        case STAGING:
        case E2E:
            return "https://cdn.perkbox.net";
        case PRODUCTION:
        default:
            // default prod for safety!
            return "https://cdn.perkbox.com";
    }
};
export var getDomain = function (tenant) {
    var tenantPrefix = getTenantPrefix(tenant);
    switch (env.ENVIRONMENT_NAME) {
        case LOCAL:
            return "http://" + tenantPrefix + "localhost:3000";
        case DEVELOPMENT:
            return "https://" + tenantPrefix + "perkbox.dev";
        case STAGING:
            return "https://" + tenantPrefix + "perkbox.net";
        case E2E:
            return "https://" + tenantPrefix + "perkbox.info";
        case PRODUCTION:
        default:
            // default prod for safety!
            return "https://" + tenantPrefix + "perkbox.com";
    }
};
export var getInternalLinkFromString = function (url, tenant) {
    var domain = getDomain(tenant);
    if (url.startsWith(domain)) {
        return url.replace(domain, "");
    }
    return null;
};
function getTenantPrefix(tenant) {
    return tenant ? tenant + "." : "";
}
export default {
    forgotPasswordRedirect: forgotPasswordRedirect,
    login: login,
    postData: postData,
    checkEmail: checkEmail,
    getDomain: getDomain,
    getLocaleUrl: getLocaleUrl,
    getCDNBundleUrl: getCDNBundleUrl,
    insightsHome: insightsHome,
    medicalHome: medicalHome,
    channelPartner: channelPartner
};
